import { DeactivateRouteService } from "src/modules/appointment/searchDoctor/popupBeforeExit/deactivate-route.service";

export const appointmentRouteDef = [
    {
        path: 'add-appointment',
        component: 'AddAppointmentComponent',
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: ':id/:resource/appointment-reschedule',
        component: 'AddAppointmentComponent',
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: ':id/:resource/appointment-direct-reschedule',
        component: 'AddAppointmentComponent',
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: ':resource/viewPrescription',
        component: 'ViewPrescriptionComponent',
        data: {
            selector: 'app-view-prescription',
        }
    },
    {
        path: 'appointment_patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource: 'per_patient_track_appointment'
        }
    },
    {
        path: ':id/:resource/review',
        component: 'ReviewOrderModalComponent',
        data: {
            selector: 'kx-review-order-modal'
        }
    },
    {
        path: 'payment_status',
        component: 'PaymentStatusComponent',
        data: {
            selector: 'kx-payment-status'
        }
    },
    {
        path: ':id/:resource/appointment-view',
        component: 'AddAppointmentComponent',
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: 'searchdoctor',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/telephonic',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    //searchspeciality
    {
        path: 'searchdoctor/searchspeciality',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    //searchdepartment

    {
        path: 'searchdoctor/searchdepartment',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    // END HERE

    //groupprcatice
    {
        path: 'searchdoctor/grouppractice',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/grouppractice',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/grouppractice',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    // END HERE
    //day/prime opd
    {
        path: 'searchdoctor/searchdepartment/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchspeciality/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchdepartment/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchspeciality/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/general',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/prime',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    //END HERE

    //timeadded
    {
        path: 'searchdoctor/searchdepartment/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchdepartment/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchspeciality/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchdepartment/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchspeciality/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/general/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/prime/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },

    {
        path: 'searchdoctor/grouppractice/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/grouppractice/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/grouppractice/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },

    {
        path: 'searchdoctor/searchdepartment/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },

    {
        path: 'searchdoctor/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/slotsummary',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    //searchspeciality with date
    {
        path: 'searchdoctor/searchspeciality/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/searchdate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    //time routes ended here

    //clear date route

    {
        path: 'searchdoctor/searchdepartment/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchdepartment/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchspeciality/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchdepartment/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/searchspeciality/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/general/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/prime/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },

    {
        path: 'searchdoctor/grouppractice/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/grouppractice/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/grouppractice/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },

    {
        path: 'searchdoctor/searchdepartment/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchdepartment/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchdepartment/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },

    {
        path: 'searchdoctor/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    //searchspeciality with date
    {
        path: 'searchdoctor/searchspeciality/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchopd/searchspeciality/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchteleconsultation/searchspeciality/cleardate',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    // clear date end here
    {
        path: 'searchspeciality',
        component: "SearchdoctorappointmentgroupComponent",
        data: {
            selector: 'app-searchdoctorappointmentgroup'
        }
    },
    {
        path: ':id/:title/:type/event-calendar',
        component: 'EventCalendarComponent',
        data: {
            selector: 'kx-event-calendar'
        }
    },
    {
        path: 'searchvaccine',
        component: "SearchDoctorappointmentComponent",
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/:practice_type/:type',
        component: "SearchDoctorappointmentComponent",
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdoctor/:practice_type/:type/:facility_id',
        component: "SearchDoctorappointmentComponent",
        data: {
            selector: 'kx-search-doctorappointment',
            bannerJson: {
                account_aware: true,
                args: "id:!!!facility_id!!!"
            }
        }
    },
    {
        path: 'searchdoctor/:practice_type/:type/:facility_id/:speciality',
        component: "SearchDoctorappointmentComponent",
        data: {
            selector: 'kx-search-doctorappointment',
            bannerJson: {
                account_aware: true,
                args: "id:!!!facility_id!!!"
            }
        }
    },
    {
        path: 'searchdoctor/:practice_type/:type/:facility_id/:speciality/:speciality_id',
        component: "SearchDoctorappointmentComponent",
        data: {
            selector: 'kx-search-doctorappointment',
            bannerJson: {
                account_aware: true,
                args: "id:!!!facility_id!!!"
            }
        }
    },
    {
        path: 'speciality/:practice_type/:type/:facility_id',
        component: "SelectSpecialityComponent",
        data: {
            selector: 'kx-selectspeciality',
            bannerJson: {
                account_aware: true,
                args: "id:!!!facility_id!!!"
            }
        }
    },
    {
        path: 'csp_appointment',
        component: 'CSPAppointment',
        data: {
            selector: 'app-csp-appointment',
            action: 'LIST',
            resource: 'appointment'
        }
    },
    {
        path: 'diagnostic-appointment/:type',
        component: 'DiagnosticAppointmentComponent',
        data: {
            selector: 'app-diagnostic-appointment'
        }
    },
    {
        path: 'diagnostic-appointment/:type/:sub_type',
        component: 'DiagnosticAppointmentComponent',
        data: {
            selector: 'app-diagnostic-appointment'
        }
    },
    {
        path: 'package-detail',
        component: 'PackageListComponent',
        data: {
            selector: 'kx-package-list'
        }
    },
    {
        path: 'verify-kyc',
        component: 'VerifyKycComponent',
        data: {
            selector: 'app-verify-kyc'
        }
    },
    {
        path: 'vaccination-detail',
        component: 'VaccinationListComponent',
        data: {
            selector: 'app-vaccination-list'
        }
    },
    {
        path: ':type/dashboard',
        component: 'EventCalendarComponent',
        data: {
            selector: 'kx-event-calendar',
            type: 'calendar_event'
        }
    },
    {
        path: 'generate-request',
        component: 'RequestAppointmentComponent',
        data: {
            selector: 'kx-request-appointment'
        }
    },
    {
        path: 'searchphc/:id',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'searchdiagnostics',
        component: "SearchDoctorappointmentComponent",
        canDeactivate: [DeactivateRouteService],
        data: {
            selector: 'kx-search-doctorappointment'
        }
    },
    {
        path: 'generate-request-order',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'patient_request_service',
            action: 'LIST',

        }
    },
    {
        path: ":type/doctor-summary1",
        "component": "EventCalendarComponent",
        data: {
            "selector": "kx-event-calendar",
            "resource": "doctor_visit_summary_calendar"
        }
    },
    {
        path: ":type/doctor-summary",
        component: "DoctorSlotSummaryComponent",
        data: {
            "selector": "app-doctor-slot-summary",
            "resource": "doctor_visit_summary_calendar"
        }
    },
    {
        path: "uploadedfile_metadata",
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'diagnostic_view_upload_document',
            action: 'IMAGE_VIEWER',
        }
    }
]


